import { put } from 'redux-saga/effects';

import * as actionTypes from 'constants/actionTypes';

export function* replaceFirebaseOnlineStatus(data) {
  yield put({
    type: actionTypes.SET_FIREBASE_ONLINE_STATUS,
    payload: data,
  });
}
